import { LiveIcon } from "@/assets/icons";
import { Button } from "@/components/button";
import dayjs from "dayjs";
import IconStopFilled from "~icons/tabler/player-stop-filled";
import {
  usePlaybackMediator,
  useTimelinePlayback,
} from "@/contexts/playback-context";
import { useSelector } from "@legendapp/state/react";
import { useTracksBuffer } from "@/services/buffer-controller";
import { resetGlobalObservables } from "@/virtual-store/state";
import { toast } from "react-hot-toast";

export const LiveButton = () => {
  const timelinePlayback = useTimelinePlayback();
  const mediator = usePlaybackMediator();
  const [tracksBuffer] = useTracksBuffer();
  const isLive = useSelector(() => timelinePlayback.liveMeta.isLive.get());
  const isPlaying = useSelector(
    () => timelinePlayback.playbackState.get() === "playing"
  );

  const isLiveBehind = useSelector(() => {
    if (!isLive) return false;

    const currentTime = timelinePlayback.currentTime.peek();
    const nextMinDatetime = tracksBuffer.actualRange$.end.get();

    return dayjs(nextMinDatetime).diff(currentTime, "second") > 10;
  });

  const onLiveModeClick = async () => {
    if (isLive && isLiveBehind) {
      const nextMinDatetime = tracksBuffer.actualRange$.end.peek();

      if (!nextMinDatetime) {
        return toast.error("Next min datetime does not exist");
      }

      mediator.seek(nextMinDatetime, "time-cursor");
      mediator.seekVideo(nextMinDatetime);
      mediator.play();
    } else {
      resetGlobalObservables();
      mediator.startLive();
    }
  };

  return (
    <>
      {isLive && (
        <Button
          onClick={() => {
            mediator.stopLive();
          }}
        >
          <IconStopFilled />
          <span className="whitespace-nowrap">Stop Live</span>
        </Button>
      )}
      <Button
        onClick={onLiveModeClick}
        disabled={isLive && isPlaying && !isLiveBehind}
        className="disabled:cursor-not-allowed disabled:opacity-100"
      >
        <LiveIcon
          className={isLive && !isLiveBehind ? "text-red-500" : "text-gray-300"}
        />
        <span>Live</span>
      </Button>
    </>
  );
};
